export default __webpack_public_path__ + "static/media/shield-done-filled.057a5f83.svg";